module.exports = __webpack_public_path__ + "assets/img/ENVIOPENDIENTEDEPAGO.8f4c81fd.svg";